export default function OnlineStore() {
  return (
    <section className="bg-[#2a3820]">
      {/* ── Hook Banner ── */}
      <div className="relative overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-[360px] md:min-h-[400px]">
          <div className="flex flex-col justify-center px-6 md:px-16 py-14 md:py-20">
            <p className="text-white/40 text-xs tracking-[0.4em] mb-6">EXPERIENCE</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-6">
              自然の中で、<br />
              <span className="text-[#b8d4a0]">呼吸が深まる。</span>
            </h2>
            <p className="text-white/60 text-sm leading-loose max-w-xs">
              身体がゆるみ、整い、そして動き出す。<br />
              静かな環境の中で、自分の身体と向き合う時間。
            </p>
          </div>
          <div className="relative overflow-hidden h-56 md:h-auto">
            <img
              src="https://public.readdy.ai/ai/img_res/13c5ae2cf5955ea45515dcc8c6caa9ee.jpg"
              alt="KUU体験"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#2a3820]/80 via-[#2a3820]/20 to-transparent" />
          </div>
        </div>
      </div>

      {/* ── 体験説明 ── */}
      <div className="border-t border-white/10">
        {/* Concept */}
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-auto md:min-h-[360px]">
          <div className="relative overflow-hidden h-56 md:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=tranquil%20Japanese%20wellness%20room%20with%20wooden%20elements%2C%20green%20moss%20wall%2C%20soft%20natural%20light%20through%20shoji%20screen%2C%20treatment%20futon%20on%20tatami%20floor%2C%20minimalist%20healing%20space%2C%20earthy%20neutral%20tones%2C%20peaceful%20Kamakura%20hidden%20salon%20interior&width=700&height=500&seq=online_kit01&orientation=landscape"
              alt="隠れ家サロン空間"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-l from-[#2a3820]/60 to-transparent" />
          </div>
          <div className="flex flex-col justify-center px-6 md:px-16 py-12 md:py-16">
            <p className="text-[#b8d4a0] text-xs tracking-[0.35em] mb-3">HIDDEN SALON</p>
            <h3 className="font-serif text-2xl md:text-3xl text-white leading-snug mb-5">
              ただ癒されるだけでなく、<br />
              「本来の状態」に戻っていく。
            </h3>
            <p className="text-white/65 text-sm leading-loose">
              ここでは、一時的な気持ちよさではなく<br className="hidden md:block" />
              身体が本来持っている機能と感覚を取り戻します。<br className="hidden md:block" />
              永福寺跡を見渡す静かな空間で、<br className="hidden md:block" />
              神経と身体が、ゆっくりと整っていきます。
            </p>
          </div>
        </div>

        {/* 3つのポイント */}
        <div className="bg-[#243318] px-6 md:px-16 py-12">
          <p className="text-white/40 text-xs tracking-[0.4em] mb-8">KUUの空間</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {[
              { label: "自然環境", desc: "永福寺跡を見渡す緑に囲まれた空間。自然の中にいるだけで、神経系の緊張がほどけていきます。" },
              { label: "完全個室", desc: "他のお客様を気にせず過ごせるプライベート空間。自分のペースで、じっくりと向き合えます。" },
              { label: "統合アプローチ", desc: "整体とトレーニングの知識を組み合わせ、来るたびに身体の状態が変わっていくのを感じられます。" },
            ].map((item) => (
              <div key={item.label} className="border-t border-white/15 pt-6">
                <h4 className="text-white font-medium text-sm tracking-wide mb-3">{item.label}</h4>
                <p className="text-white/55 text-sm leading-loose">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* こんな方に */}
        <div className="px-6 md:px-16 py-12">
          <p className="text-white/40 text-xs tracking-[0.4em] mb-8">こんな方に</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { icon: "ri-run-line", scene: "動ける身体を取り戻したい", detail: "疲れにくく、パフォーマンスの上がる身体づくりをしたい方に。" },
              { icon: "ri-mental-health-line", scene: "心と神経まで整えたい", detail: "ストレスや自律神経の乱れを根本からケアしたい方に。" },
              { icon: "ri-leaf-line", scene: "自然の中でゆっくりしたい", detail: "都市の喧騒を離れ、静かな環境で自分の時間を持ちたい方に。" },
            ].map((item) => (
              <div key={item.scene} className="flex gap-4 items-start">
                <div className="w-9 h-9 flex items-center justify-center shrink-0 mt-0.5">
                  <i className={`${item.icon} text-[#b8d4a0] text-xl`} />
                </div>
                <div>
                  <p className="text-white text-sm font-medium mb-1">{item.scene}</p>
                  <p className="text-white/55 text-sm leading-relaxed">{item.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 出張対応 */}
        <div className="bg-[#1e2b14] px-6 md:px-16 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <p className="text-white/40 text-xs tracking-[0.35em] mb-1">出張対応あり</p>
            <p className="font-serif text-white text-lg md:text-xl leading-snug">
              ご自宅やご希望の場所でも施術が可能です。<br />
              <span className="text-white/50 text-sm font-sans font-normal">鎌倉市内：+¥1,000</span>
            </p>
          </div>
          <a
            href="#reserve"
            onClick={(e) => { e.preventDefault(); document.getElementById("reserve")?.scrollIntoView({ behavior: "smooth" }); }}
            className="bg-[#b8d4a0] text-[#1e2b14] text-sm font-medium tracking-widest px-8 md:px-10 py-4 rounded-sm hover:bg-[#cce4b0] transition-colors cursor-pointer whitespace-nowrap self-start sm:self-auto"
          >
            予約する
          </a>
        </div>
      </div>
    </section>
  );
}
